import { render, staticRenderFns } from "./aiCard.vue?vue&type=template&id=ca08baec&scoped=true"
import script from "./aiCard.vue?vue&type=script&lang=js"
export * from "./aiCard.vue?vue&type=script&lang=js"
import style0 from "./aiCard.vue?vue&type=style&index=0&id=ca08baec&prod&lang=scss"
import style1 from "./aiCard.vue?vue&type=style&index=1&id=ca08baec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca08baec",
  null
  
)

export default component.exports